export default __webpack_public_path__ + "static/media/img_ibobby05.1f85364b.png";